// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2zS4O","assignButton":"CreateEditEquipmentSchedule_assignButton__1AfKj"};